import { render, staticRenderFns } from "./TenManageQueryPage.vue?vue&type=template&id=ab37803a&"
import script from "./TenManageQueryPage.vue?vue&type=script&lang=js&"
export * from "./TenManageQueryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports